var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPanorama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66536 19.3327C2.0237 19.3327 1.47439 19.1042 1.01745 18.6473C0.560504 18.1903 0.332031 17.641 0.332031 16.9993V2.99935C0.332031 2.35768 0.560504 1.80838 1.01745 1.35143C1.47439 0.894488 2.0237 0.666016 2.66536 0.666016H21.332C21.9737 0.666016 22.523 0.894488 22.9799 1.35143C23.4369 1.80838 23.6654 2.35768 23.6654 2.99935V16.9993C23.6654 17.641 23.4369 18.1903 22.9799 18.6473C22.523 19.1042 21.9737 19.3327 21.332 19.3327H2.66536ZM2.66536 16.9993H21.332V2.99935H2.66536V16.9993ZM4.9987 14.666H18.9987L14.6237 8.83268L11.1237 13.4993L8.4987 9.99935L4.9987 14.666Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPanorama);
export default __webpack_public_path__ + "static/media/icon_panorama.8da95cdbd183df399e1c614fd345ff29.svg";
export { ForwardRef as ReactComponent };